module.exports = "table td {\n  white-space: normal;\n  vertical-align: top; }\n\ntable tr {\n  vertical-align: top; }\n"